export default __webpack_public_path__ + "static/media/reveniew.98441f0c.svg";